import type { FC } from 'react';
import { useNormalizedDeviationStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import StudioHeaderMobile from '../../../StudioHeaderMobile';
import { useDraftsSelect } from '../../../../hooks/useDraftsSelect';
import { STUDIO_DEVIATIONS_STREAM } from '../../../../../constants';
import DeviationsTab from '../../_partials/DeviationsTab';
import LayoutContainer from '../../_partials/LayoutContainer';

interface Props {}

const DefaultLayout: FC<Props> = () => {
  const { streamId, streamConfig, streamThrottle } = STUDIO_DEVIATIONS_STREAM;
  const { items: deviations, isFetching } = useNormalizedDeviationStream(
    streamId,
    streamThrottle,
    { ...streamConfig }
  );

  const {
    selected,
    selectedCount,
    allIsSelected,
    hasSelection,
    onSelect,
    onSelectAll,
  } = useDraftsSelect(deviations);

  return (
    <LayoutContainer>
      <StudioHeaderMobile
        selectedCount={selectedCount}
        allIsSelected={allIsSelected}
        onSelectAll={onSelectAll}
      />
      <DeviationsTab
        deviations={deviations}
        isFetching={isFetching}
        selected={selected}
        hasSelection={hasSelection}
        onSelect={onSelect}
      />
    </LayoutContainer>
  );
};
DefaultLayout.displayName = 'DefaultLayout';

export default DefaultLayout;
